import React, {useState, useEffect, useContext} from 'react';
import Button from "../../UI/Button/Button";
import TransitionsModal from "../../UI/Modal/Modal";
import style from "../Users/users.module.css";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import YandexMap from "../Map/Map";
import {useTranslation} from "react-i18next";
import axios from '../../../API/api';
import {Store} from "../../../Store";
import CircularProgress from "@material-ui/core/CircularProgress";
import {toast} from "react-toastify";
import Input from "../../UI/Input/TextField";

export default function AddOrg(props) {
   const {t} = useTranslation();
   const {state, dispatch} = useContext(Store);
   const [open, setOpen] = useState(false);
   const [mfo, setMfo] = useState(props.updated === true && props.updateInfo.mfos.length !== 0 ? props.updateInfo.mfos : [{mfo: ''}]);
   const [account, setAccount] = useState(props.updated === true && props.updateInfo.paymentAccounts.length !== 0 ? props.updateInfo.paymentAccounts : [{account: ''}]);
   const [address, setAddress] = useState(props.updated === true && props.updateInfo.addresses.length !== 0 ? props.updateInfo.addresses : [{
      name: '',
      latitude: '49',
      longitude: '61'
   }]);
   const [contact, setContact] = useState(props.updated === true && props.updateInfo.contacts.length !== 0 ? props.updateInfo.contacts : [{
      email: '',
      phoneNumber: ''
   }]);
   const [bDirection, setBdirection] = useState([]);
   const [financier, setFinancier] = useState([]);
   const [inputs, setInputs] = useState(props.updated === true ? props.updateInfo : {});
   const [data, setData] = useState({
      location: '',
      coordinates: ''
   });
   const [loader, setLoader] = useState(false);
   const [error, setError] = useState(false);

   useEffect(() => {
      if (open === true) {
         Promise.all([
            axios.get(`/api/v1/business/directions`, {headers: {Authorization: `Bearer ${state.token}`}}),
            axios.get(`/api/v1/users?isFinancier=true`, {headers: {Authorization: `Bearer ${state.token}`}})
         ]).then(function (results) {
            const bussiness = results[0];
            const financier = results[1];
            setBdirection(bussiness?.data?.data);
            setFinancier(financier?.data?.data);
            setLoader(true)
         }).catch((err) => {
            console.log(err)

         })
      }
   }, [state.updated, open])

   function handleAddMfo() {
      setMfo([...mfo, {mfo: ''}]);
   }

   function handleRemoveMfo(i) {
      const list = [...mfo];
      list.splice(i, 1);
      setMfo(list);
   }

   function handleAddAccount() {
      setAccount([...account, {account: ''}]);
   }

   function handleRemoveAccount(i) {
      const list = [...account];
      list.splice(i, 1);
      setAccount(list);
   }

   function handleAddAddress() {
      setAddress([...address, {name: '', latitude: '41', longitude: '69'}]);
   }

   function handleRemoveAddress(i) {
      const list = [...address];
      list.splice(i, 1);
      setAddress(list);
   }

   function handleAddContact() {
      setContact([...contact, {email: '', phoneNumber: ''}]);
   }

   function handleRemoveContact(i) {
      const list = [...contact];
      list.splice(i, 1);
      setContact(list);
   }

   const handleOpen = () => {
      setOpen(true);
   }

   const handleClose = () => {
      setOpen(false);
      setInputs({});
   };

   const handleInputChange = (event, i, state) => {
      event.persist();
      const {name, value} = event.target;
      if (state === 'mfo') {
         const list = [...mfo];
         list[i][name] = value;
         setMfo(list);
      } else if (state === 'account') {
         const list = [...account];
         list[i][name] = value;
         setAccount(list);
      } else if (state === 'address') {
         const list = [...address];
         list[i][name] = value;
         setAddress(list);
      } else if (state === 'contact') {
         const list = [...contact];
         list[i][name] = value;
         setContact(list);
      } else if (state === 'addOrg') {
         setInputs(inputs => ({...inputs, [name]: event.target.value}));
      }
   }
   const handleInputComplete = (event, newValue, name) => {
      event.persist();
      dispatch({type: 'PAGE', payload: 0});
      setInputs(inputs => ({...inputs, [name]: event.target.innerText}));
      if (name === 'financierUserId' && newValue) {
         setInputs(inputs => ({...inputs, 'financierUserId': newValue.id}))
      } else if (name === 'businessDirectionId' && newValue) {
         setInputs(inputs => ({...inputs, 'businessDirectionId': newValue.id}))
      }
   }

   const handleSubmitSingle = (e) => {
      e.preventDefault();
      let data = {
         "addresses": address.filter(v => v.name !== ""),
         "businessDirectionId": inputs.businessDirectionId,
         "contacts": contact.filter(v => v.email && v.phoneNumber !== ""),
         "financierUserId": inputs.financierUserId,
         "forObjectName": true,
         "inn": inputs.inn,
         "mfos": mfo.filter(v => v.mfo !== ""),
         "name": inputs.name,
         "nick": inputs.nick,
         "paymentAccounts": account.filter(v => v.account !== "")
      }
      let update = {
         "id": props.updated === true ? props.updateInfo.id : '',
         "addresses": address.filter(v => v.name !== ""),
         "businessDirectionId": inputs.businessDirectionId,
         "contacts": contact.filter(v => v.email && v.phoneNumber !== ""),
         "financierUserId": inputs.financierUserId,
         "forObjectName": true,
         "inn": inputs.inn,
         "mfos": mfo.filter(v => v.mfo !== ""),
         "name": inputs.name,
         "nick": inputs.nick,
         "paymentAccounts": account.filter(v => v.account !== "")
      }
      axios[props.updated === true ? 'put' : 'post'](props.updated === true ? props.updatedUrl : `/api/v1/organization/create`,
         props.updated === true ? update : data, {headers: {Authorization: `Bearer ${state.token}`}})
         .then(res => {
            setInputs({})
            toast.configure();
            toast.success((res.config.method === 'post' ? t('Added new organization') : t('Organization changed successfully')), {
               position: "top-right",
               autoClose: 3000,
               closeOnClick: true,
               pauseOnHover: true,
               draggable: true,
            });
            if (res.status === 201 || 200) {
               handleClose()
               return dispatch({type: 'UPDATED', payload: Math.random()})
            }
         })
         .catch(function (error) {
            const err = error.response.data.error
            toast.configure();
            toast.error((err.friendlyMessage ? err.friendlyMessage : err), {
               position: "top-right",
               autoClose: 3000,
               closeOnClick: true,
               pauseOnHover: true,
               draggable: true,
            });
            if (error.response ? error.response.status === 401 : '') {
               localStorage.removeItem('id_token');
               return dispatch({type: 'SET_TOKEN', payload: ''})
            }
         })
   }
   const form = [
      {
         label: t('orgName'),
         variant: 'outlined',
         name: 'name',
         value: 'name',
         textArea: true,
         nested: false
      },
      {
         label: t('orgCode'),
         variant: 'outlined',
         name: 'nick',
         value: 'nick',
         textArea: true,
         nested: false
      },
      {
         label: t('businessDirection'),
         variant: 'outlined',
         name: 'businessDirectionId',
         value: 'businessDirectionId',
         textArea: false,
         nested: false,
         option: bDirection,
         optionName: 'name'
      },
      {
         label: t('inn'),
         variant: 'outlined',
         name: 'inn',
         value: 'inn',
         textArea: true,
         nested: false,
      },
      {
         label: t('financier'),
         variant: 'outlined',
         name: 'financierUserId',
         value: 'financierUserId',
         textArea: false,
         nested: false,
         option: financier,
         optionName: 'shortName'
      },
   ]

   return (
      <div>
         {props.img ? <img src={props.img} alt="" onClick={handleOpen}/> :
            <Button btnType="addUser" clicked={handleOpen}>{t('add')}</Button>}
         <TransitionsModal open={open} handleClose={handleClose}>
            <div className={[state.mode === 'light' ? style.modalLight : style.modalDark, "drag-modal"].join(' ')} onSubmit={handleSubmitSingle}>
               {loader === true ?
                  <div>
                     <p>{props.updated === true ? t('Change organization') : t('addOrg') } </p>
                     <Grid className={style.form} container spacing={3}>
                        {form.map((element, i) => {
                           return (
                               <Grid item xs={12} md={3} xl={3} key={i}>
                                  {element.textArea === true ?
                                      <Input
                                          key={i}
                                          inputType={'textField'}
                                          error={error}
                                          variant="outlined"
                                          size="small"
                                          name={element.name}
                                          type={element.name}
                                          nested={element.nested}
                                          value={inputs[element.value] || null}
                                          onChange={(e) => handleInputChange(e, i, 'addOrg')}
                                          label={element.label}
                                          disabled={element.disabled}
                                      /> :
                                      <Input
                                          inputType={'autoComplete'}
                                          error={error}
                                          style={{width: '100%', marginRight: 27}}
                                          id="combo-box-demo"
                                          options={element.option}
                                          defaultValue={props.updated ? element.option.find(v => v.id === inputs[element.name]) : ''}
                                          getOptionLabel={(option) => option[`${element.optionName}`]}
                                          onChange={(e, newValue) => handleInputComplete(e, newValue, element.name)}
                                          disabled={element.disabled}
                                          type={element.name}
                                          renderInput={(params) => <TextField
                                              {...params} label={element.label} variant="outlined"
                                              InputLabelProps={{className: style.label}}
                                              name={element.name}
                                              size="small"/>}
                                      />
                                  }
                               </Grid>
                           )
                            }
                        )}
                     </Grid>
                     <Grid container spacing={3}>
                        <Grid item xs={12} md={4} xl={4}>
                           <p>{t('mfo')}</p>
                           {mfo.map((field, idx) =>
                              <div className={style.add} key={idx}>
                                 <Input
                                    key={idx}
                                    inputType={'textField'}
                                    error={error}
                                    variant="outlined"
                                    size="small"
                                    name={'mfo'}
                                    type={'mfo'}
                                    value={field.mfo}
                                    onChange={(e) => handleInputChange(e, idx, 'mfo')}
                                    style={{width: '100%', marginRight: 27}}
                                 />
                                 {idx + 1 !== mfo.length && mfo.length > 1 ?
                                    <Button btnType="remove" clicked={() => handleRemoveMfo(idx)}>-</Button> : ''}
                                 {idx + 1 === mfo.length ?
                                    <Button btnType="add" clicked={() => handleAddMfo()}>+</Button> : ''}
                              </div>
                           )}
                        </Grid>
                        <Grid item xs={12} md={4} xl={4}>
                           <p>{t('checkAccount')}</p>
                           {account.map((field, idx) =>
                              <div className={style.add} key={idx}>
                                 <Input
                                    key={idx}
                                    inputType={'textField'}
                                    error={error}
                                    variant="outlined"
                                    size="small"
                                    name={'account'}
                                    type={'account'}
                                    value={field.account}
                                    onChange={(e) => handleInputChange(e, idx, 'account')}
                                    style={{width: '100%', marginRight: 27}}
                                 />
                                 {idx + 1 !== account.length && account.length > 1 ?
                                    <Button btnType="remove" clicked={() => handleRemoveAccount(idx)}>-</Button> : ''}
                                 {idx + 1 === account.length ?
                                    <Button btnType="add" clicked={() => handleAddAccount()}>+</Button> : ''}
                              </div>
                           )}
                        </Grid>
                     </Grid>
                     <Grid container spacing={3}>
                        <Grid item xs={8} xl={8} className={style.userAddress}>
                           <p>{t('address')}</p>
                           {address.map((field, idx) =>
                              <div className={style.map} key={idx}>
                                 <div className={style.add}>
                                    <Input
                                       key={idx}
                                       inputType={'textField'}
                                       error={error}
                                       variant="outlined"
                                       size="small"
                                       name={'name'}
                                       type={'name'}
                                       value={field.name}
                                       onChange={(e) => handleInputChange(e, idx, 'address')}
                                       style={{width: '100%', marginRight: 27}}
                                    />
                                    {idx + 1 !== address.length && address.length > 1 ?
                                       <Button btnType="remove"
                                               clicked={() => handleRemoveAddress(idx)}>-</Button> : ''}
                                    {idx + 1 === address.length ?
                                       <Button btnType="add" clicked={() => handleAddAddress()}>+</Button> : ''}
                                 </div>
                                 <YandexMap setData={setData}/>
                              </div>
                           )}
                        </Grid>
                        <Grid item xs={7} xl={7} className={style.userContact}>
                           <p>{t('contact')}</p>
                           {contact.map((field, idx) =>
                              <div className={style.add} key={idx}>
                                 <Input
                                    key={idx}
                                    inputType={'textField'}
                                    error={error}
                                    variant="outlined"
                                    size="small"
                                    name={'email'}
                                    type={'email'}
                                    value={field.email}
                                    label={'email'}
                                    onChange={(e) => handleInputChange(e, idx, 'contact')}
                                    style={{width: '100%', marginRight: 27}}
                                 />
                                 <Input
                                    key={idx}
                                    inputType={'textField'}
                                    error={error}
                                    variant="outlined"
                                    size="small"
                                    label={'number'}
                                    name={'phoneNumber'}
                                    type={'phoneNumber'}
                                    value={field.phoneNumber}
                                    onChange={(e) => handleInputChange(e, idx, 'contact')}
                                    style={{width: '100%', marginRight: 27}}
                                 />
                                 {idx + 1 !== contact.length && contact.length > 1 ?
                                    <Button btnType="remove" clicked={() => handleRemoveContact(idx)}>-</Button> : ''}
                                 {idx + 1 === contact.length ?
                                    <Button btnType="add" clicked={() => handleAddContact()}>+</Button> : ''}
                              </div>
                           )}
                        </Grid>
                     </Grid>
                     <div className={style.action}>
                        <Button btnType="cancel" clicked={handleClose}>{t('cancel')}</Button>
                        <Button btnType="save" clicked={handleSubmitSingle}>{t('save')}</Button>
                     </div>
                  </div> : <CircularProgress size={30}/>}
            </div>
         </TransitionsModal>
      </div>
   )
}